<lib-logo></lib-logo>
<div class="container">
    <lib-exhibit-carousel></lib-exhibit-carousel>
    <lib-buffer [bufferHeight]="16"></lib-buffer>
    <lib-ar></lib-ar>
    <lib-buffer [bufferHeight]="12"></lib-buffer>
    <lib-audio-tours></lib-audio-tours>
    <lib-buffer [bufferHeight]="16"></lib-buffer>
    <lib-events></lib-events>
    <lib-buffer [bufferHeight]="12"></lib-buffer>
    <lib-nearby-carousel></lib-nearby-carousel>
    <lib-action-group [buttons]="buttons"></lib-action-group>
    <lib-buffer [bufferHeight]="100"></lib-buffer>
</div>